import { render } from "./WorkoutPage.vue?vue&type=template&id=57f49a53"
import script from "./WorkoutPage.vue?vue&type=script&lang=js"
export * from "./WorkoutPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__